import "./details-modal.scss";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import BillingTransactionStore from "../../stores/billing-transaction-store";
import { useEffect } from "react";
import { observer } from "mobx-react";
import ParentModalContent from "./parent-modal-content";
import ChildModalContent from "./child-modal-content";

interface IBillingDetailsModalProps {
    onClose: () => void;
    transaction: BillingTransactionStore;
}

export const getPartnerLogo = (partnerId: string) => {
    let logoContent = null;
    try {
        logoContent = <img src={require(`../../../../images/partner-logos/${partnerId}.svg`).default}
                           alt='partner logo'
                           className='partner-logo'
        />
    } catch (error) {
        console.error(error);
    }
    return logoContent;
}

const BillingDetailsModal: React.FC<IBillingDetailsModalProps> = observer(({ onClose, transaction }) => {
    useEffect(() => {
        transaction.fetchPreviosUsage();
    }, [transaction]);

    return (
        <DefaultModalLayout isCloseDisabled={false} onCloseClicked={onClose}>
            <div>
                { !transaction.parentBilledUser &&
                    <ParentModalContent transaction={transaction} />
                }
                { transaction.parentBilledUser &&
                    <ChildModalContent transaction={transaction} />
                }
            </div>
        </DefaultModalLayout>
    );
});

export default BillingDetailsModal;
